import { Select, Button1, TagInput } from "../../../index";
import refreshIcon from "../../../../assets/icons/refresh-icon.png";
import downIcon from "../../../../assets/icons/chevron-down.png";
import circle from "../../../../assets/icons/Ellipse 81.png";
import FeeBreakdown from "../../../fee-breakdown/FeeBreakdown";

const fmt = (n, c) =>
  `${Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${c || ""}`.trim();

const InternationalFundReview = ({
  sourceAccount,
  transferData,
  beneficiaryData,
  quote,
  submitting,
  error,
  onConfirm,
  updateTransfer,
  onClick,
}) => {
  const sourceCurrency = sourceAccount?.currency || "AUD";
  const balanceBefore = Number(sourceAccount?.availableBalance || 0);
  const sendAmount = Number(transferData.sourceAmount || 0);
  const fees = Number(
    quote?.transferFee ?? quote?.fee ?? quote?.fees ?? 0
  );
  const balanceAfter = balanceBefore - sendAmount - fees;

  const internationalFundReviewDetails = [
    {
      name: "Amount you want to send",
      info: fmt(sendAmount, sourceCurrency),
    },
    {
      name: "Balance Before the below transaction",
      info: fmt(balanceBefore, sourceCurrency),
    },
    {
      name: "Balance After the below transaction",
      info: fmt(balanceAfter, sourceCurrency),
    },
    {
      name: "Transaction fees",
      info: fmt(fees, sourceCurrency),
    },
  ];

  const reviewDetails = [
    { name: "Bank Name", info: beneficiaryData.bankName || "-" },
    { name: "SWIFT/BIC Code", info: beneficiaryData.swiftCode || "-" },
    { name: "Account number", info: beneficiaryData.iban || "-" },
    { name: "IBAN", info: beneficiaryData.iban || "-" },
    { name: "Country", info: beneficiaryData.bankCountry || "-" },
    {
      name: "Reference",
      info: transferData.referenceNote || "-",
    },
    { name: "Purpose", info: transferData.purpose || "-" },
    {
      name: "Transfer date",
      info: transferData.transferDate
        ? new Date(transferData.transferDate).toLocaleDateString()
        : "Today",
    },
  ];

  const recipientName =
    transferData.accountType === "BUSINESS"
      ? beneficiaryData.businessName
      : beneficiaryData.fullName;

  return (
    <>
      <div className="d-flex align-items-center justify-content-md-end justify-content-center mt-2  mb-2">
        <div className="d-flex flex-column gap-1">
          <div className="d-flex align-items-center gap-1">
            <span className="fs12px" style={{ color: "#7D7D7D" }}>
              Exchange rate
            </span>
            <span
              style={{ color: "#7D7D7D" }}
              className="d-flex fs12px align-items-center justify-content-center"
            >
              |
            </span>
            <span className="fs12px" style={{ color: "#7D7D7D" }}>
              {quote ? "Live" : "No quote"}
            </span>
            <img src={refreshIcon} alt="refresh" className="cursor-pointer" />
          </div>
          <div className="d-flex align-items-center gap-1 justify-content-end">
            <span className="fs14px fw-semibold">
              1 {sourceCurrency} ={" "}
              <span style={{ color: "#1bbb6b" }}>
                {Number.isFinite(Number(quote?.exchangeRate ?? quote?.midRate))
                  ? Number(quote?.exchangeRate ?? quote?.midRate).toFixed(6)
                  : "0.00"}{" "}
                {transferData.destCurrency}
              </span>
            </span>
            <img src={downIcon} alt="down" className="cursor-pointer" />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column gap-3">
        <span className="fs-5 fw-medium">Review</span>
        <div className="d-flex flex-column  intl-rev-h gap-3 flex-wrap ">
          {internationalFundReviewDetails.map(({ name, info }) => (
            <div key={name} className="d-flex flex-column gap-2">
              <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
                {name}
              </span>
              <div className="d-flex align-items-center gap-2">
                <span className=" fw-medium">{info}</span>
              </div>
            </div>
          ))}
        </div>
        {quote && <FeeBreakdown quote={quote} kind="transfer" className="mt-2" />}
      </div>

      <div className="col-12 p-3 ">
        <div className="d-flex flex-column gap-3 border rounded-3 p-3">
          <div className="d-flex flex-column gap-2">
            <span className="fs12px" style={{ color: "#7D7D7D" }}>
              Net amount you want to send
            </span>
            <div className="d-flex gap-2 align-items-center">
              <span className="fs14px fw-medium">
                {fmt(quote?.destAmount || 0, transferData.destCurrency)}
              </span>
            </div>
          </div>

          <div className="d-flex justify-content-between  align-items-center">
            <div className="d-flex flex-column gap-2">
              <span className="fs12px" style={{ color: "#7D7D7D" }}>
                Recipients
              </span>
              <div className="d-flex align-items-center gap-2">
                <img src={circle} alt="circle" />
                <div className="d-flex flex-column ">
                  <span className="fs14px fw-medium">
                    {recipientName || "-"}
                  </span>
                  <span
                    className="fs12px fw-medium"
                    style={{ color: "#7D7D7D" }}
                  >
                    {beneficiaryData.bankCountry || transferData.destCountry}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex flex-column gap-2 w-50">
              <span className="fs12px" style={{ color: "#7D7D7D" }}>
                Method
              </span>
              <Select
                value="SWIFT"
                options={[{ name: "SWIFT", value: "SWIFT" }]}
                className="p-3 w-100"
                disabled
              />
            </div>
          </div>

          <hr className="opacity-25" />

          <div className="d-flex flex-column gap-3">
            {reviewDetails.map(({ name, info }) => (
              <div key={name} className="d-flex justify-content-between">
                <span className="fs12px fw-medium" style={{ color: "#7D7D7D" }}>
                  {name}
                </span>
                <span className="fs12px fw-medium">{info}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="col-12 p-3">
        <div className="d-flex flex-column gap-3">
          <span className="fs-5 fw-medium">Additional Details</span>

          <div className="row ">
            <div className="col-lg-6 d-flex flex-column gap-2  ">
              <label className="fs12px">Category</label>
              <Select
                value={transferData.category}
                options={["Family", "Friend", "Vendor", "Employee", "Business"].map(
                  (c) => ({ name: c, value: c })
                )}
                defaultValue="Select Category"
                className="p-3"
                onChange={(e) => updateTransfer("category", e.target.value)}
              />
            </div>
            <div className=" col-lg-6 d-flex flex-column gap-2 ">
              <label className="fs12px">Tags</label>
              <TagInput
                className="border py-3 "
                inputBgColor="transparent"
                tagColor="#1bbb6b"
                tagTextColor="#000"
                limit={10}
                placeholder="Add up to 10 Tags"
              />
            </div>
          </div>
        </div>
      </div>

      {error && (
        <div className="col-12 p-2">
          <div className="fs12px" style={{ color: "#FC555B" }}>
            {error}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-md-end  justify-content-center flex-wrap p-2 gap-3">
        <Button1
          buttonName={"Previous"}
          className={"border"}
          onClick={() => onClick(1)}
        />
        <Button1
          buttonName={"Save as Draft"}
          className={"btn-outline-success"}
        />
        <Button1
          buttonName={submitting ? "Creating..." : "Create"}
          className="btn-dark "
          onClick={onConfirm}
          disabled={submitting}
        />
      </div>
    </>
  );
};

export default InternationalFundReview;
